<template>
  <div class=" flex justify-content-center" v-if="img !== null">
    <div
      class="id-file"
      style="cursor:  pointer"
      @click.prevent="openImageModal(img)"
    >
      <img class="id-file img-fluid" alt="id file" :src="img" />
    </div>
  </div>
</template>

<script>
export default {
  name: "ImageMagnifying",
  props: {
    img: {
      type: [String],
      default: null
    }
  },
  data() {
    return {
      images: []
    };
  },
  methods: {
    openImageModal(param) {
      this.images = [];
      this.$viewerApi({
        images: [param]
      });
      this.images.push(param);
      console.log(this.images);
      // this.photoLoading = true;
      console.log(param);
      setTimeout(() => this.setImage(param), 4000);
    }
  }
};
</script>

<style scoped></style>
